import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';
import { motify } from 'moti';

export const ThemeMotiColumn = withStyles(motify(CoreView)(), {style: {flexDirection: 'column'}});